<div class="dashboard-material-theme dashboard-calculated-variable-dialog">
  <dashboard-dialog-title
    [title]="isEdit ? 'Edit Calculated Variable' : 'Create New Calculated Variable'"
  ></dashboard-dialog-title>
  <mat-dialog-content class="dashboard-calculated-variable-dialog__content">
    <form
      [formGroup]="calculatedVariableForm"
      fxLayout="column"
      fxLayoutAlign="space-between strech"
      dashboardConnectForm
      [connectForm]="isEdit ? calculatedVariable : null"
    >
      <div fxLayout="row" fxLayoutAlign="space-between">
        <mat-form-field fxFlex="40" appearance="fill" class="dashboard-calculated-variable-dialog__content-input">
          <mat-label>ID</mat-label>
          <input matInput formControlName="uniqueName" />
          <mat-error *ngIf="uniqueName.hasError('required')"> ID is <strong>required</strong> </mat-error>
          <mat-error *ngIf="uniqueName.hasError('pattern')"> ID can only contain letters and numbers</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="60" appearance="fill" class="dashboard-calculated-variable-dialog__content-input">
          <mat-label>Short description</mat-label>
          <input matInput formControlName="description" />
          <mat-error *ngIf="description.hasError('required')"> Description is <strong>required</strong> </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign=" end">
        <mat-form-field fxFlex="40" appearance="fill" class="dashboard-calculated-variable-dialog__content-input">
          <input matInput (keyup)="applyFilter($event)" placeholder="Search variables" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <div fxLayout="column">
          <mat-label class="dashboard-calculated-variable-dialog__content-functions-label">Functions</mat-label>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between">
        <table
          fxLayout="column"
          fxFlex="40"
          mat-table
          [dataSource]="dataSourceCalculationNames"
          [hidden]="!dataSourceCalculationNames?.data.length"
          class="dashboard-calculated-variable-dialog__content-table"
          cdkDropList
          id="calculationNames"
          [cdkDropListData]="calculationNames"
          (cdkDropListDropped)="dropCalculationName($event)"
          cdkDropListSortingDisabled
        >
          <ng-container matColumnDef="uniqueName">
            <th fxFill fxLayout="column" fxLayoutAlign="space-around" mat-header-cell *matHeaderCellDef>ID</th>
            <td fxFill fxLayout="column" fxLayoutAlign="space-around" mat-cell *matCellDef="let uniqueName">
              {{ uniqueName }}
            </td>
          </ng-container>

          <tr
            fxLayout="row"
            mat-header-row
            *matHeaderRowDef="columnsToDisplayCalculationNamesTable"
            class="dashboard-calculated-variable-dialog__content-table-header"
          ></tr>
          <tr
            fxLayout="row"
            mat-row
            *matRowDef="let row; columns: columnsToDisplayCalculationNamesTable"
            class="dashboard-calculated-variable-dialog__content-table-row"
            cdkDrag
          ></tr>
        </table>

        <table
          fxLayout="column"
          fxFlex="60"
          mat-table
          [dataSource]="dataSourceCalculationFunctions"
          [hidden]="!dataSourceCalculationFunctions?.data.length"
          class="dashboard-calculated-variable-dialog__content-table"
          cdkDropList
          id="calculatedVariableFunctions"
          [cdkDropListData]="calculatedVariableFunctions"
          (cdkDropListDropped)="dropCalculationFunction($event)"
          cdkDropListSortingDisabled
        >
          <ng-container matColumnDef="id">
            <th fxFlex="40" fxLayout="column" fxLayoutAlign="space-around" mat-header-cell *matHeaderCellDef>Name</th>
            <td
              fxFlex="40"
              fxLayout="column"
              fxLayoutAlign="space-around"
              mat-cell
              *matCellDef="let function"
              cdkDrag
              class="dashboard-calculated-variable-dialog__content-table-row-cell"
            >
              {{ function?.id }}
            </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th fxFlex="60" fxLayout="column" fxLayoutAlign="space-around start" mat-header-cell *matHeaderCellDef>
              Description
            </th>
            <td fxFlex="60" fxLayout="column" fxLayoutAlign="space-around start" mat-cell *matCellDef="let function">
              {{ function?.description }}
            </td>
          </ng-container>

          <tr
            fxLayout="row"
            mat-header-row
            *matHeaderRowDef="columnsToDisplayCalculationFunctionsTable"
            class="dashboard-calculated-variable-dialog__content-table-header"
          ></tr>
          <tr
            fxLayout="row"
            mat-row
            *matRowDef="let row; columns: columnsToDisplayCalculationFunctionsTable"
            class="dashboard-calculated-variable-dialog__content-table-row"
          ></tr>
        </table>
      </div>
      <mat-form-field appearance="fill">
        <mat-label>Calculate Logic</mat-label>
        <textarea
          class="dashboard-calculated-variable-dialog__content-text-area"
          matInput
          rows="5"
          formControlName="formula"
        >
        </textarea>
        <mat-error *ngIf="formula.hasError('required')"> Formula is <strong>required</strong> </mat-error>
      </mat-form-field>
      <div fxLayout="row" fxLayoutAlign="end">
        <button mat-button (click)="submitCalculatedVariable()">
          {{ 'save' | uppercase }}
        </button>
      </div>
    </form>
  </mat-dialog-content>
</div>
